import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  searchValue: any;

  constructor() {}

  ngOnInit() {

  }

  search() {
    const formatted = this.searchValue.trim().replace(/\s+/g, '+');
    const url = `https://n-somerset.gov.uk/search/gnsc?keys=${formatted}`;
    window.location.href = url;
  }
}
